import { ITheme } from 'survey-core'

export const darkTheme: ITheme = {
  themeName: 'sharp',
  colorPalette: 'dark',
  isPanelless: false,
  backgroundImage: '',
  backgroundImageFit: 'cover',
  backgroundImageAttachment: 'scroll',
  backgroundOpacity: 1,
  cssVariables: {
    '--background': '#263238',
    '--background-dim': '#171E21',
    '--foreground': '#F0F3F5',
    '--ctr-surface-placeholder-text-title-color': '#F0F3F5',
    '--ctr-surface-placeholder-text-description-color': '#F0F3F5',
    '--lbr-question-panel-background-color': '#3a3a3a',
    '--ctr-list-item-text-color': '#F0F3F5',
    '--ctr-list-item-text-color-hovered': '#F0F3F5',
    '--ctr-list-item-background-color-hovered': '#171E21',
    '--ctr-button-background-color-hovered': '#000000',
    '--ctr-list-search-text-color': '#F0F3F5',
    '--background-dim-light': '#171E21',
    '--sjs-font-pagetitle-color': '#F0F3F5',
    '--sjs-general-forecolor-light': 'rgb(185, 178, 178, 0.45)',
    '--sjs-font-editorfont-color': '#F0F3F5',
    '--sjs-questionpanel-hovercolor': '#3a3a3a',
    '--sjs-primary-backcolor': '#2186A6',
    '--sjs-primary-backcolor-dark': '#42A4C2',
  },
  header: {
    height: 0,
    mobileHeight: 0,
    inheritWidthFrom: 'survey',
    textAreaWidth: 0,
    backgroundImageFit: 'cover',
    backgroundImageOpacity: 100,
    overlapEnabled: false,
    logoPositionX: 'left',
    logoPositionY: 'top',
    titlePositionX: 'left',
    titlePositionY: 'bottom',
    descriptionPositionX: 'left',
    descriptionPositionY: 'bottom',
  },
}

export default function applyCustomClass(themeMode: string) {
  const styles = document.createElement('style')

  if (themeMode === 'dark') {
    styles.innerHTML = `
        .css-9rpbad-MuiPaper-root-MuiAppBar-root {
            background-color : #263238;
        }
        `
  } else {
    styles.innerHTML = `
        .css-9rpbad-MuiPaper-root-MuiAppBar-root {
            background-color : rgb(240, 244, 245);
        }
        `
  }
  document.head.appendChild(styles)
}
